import React, { use, useEffect, useState, useContext, useMemo } from 'react';
// import { useQuery } from '@apollo/client';
import { getProductsByVariantType, refetchProductsByVariantType } from '../api/storefrontApi.jsx';
import ProductItem from './ProductItem.jsx';
import Payment from './Payment.jsx';
import { PaymentProvider, PaymentContext } from '../store/PaymentContext.jsx';
import { Tooltip, Toast, Popover } from 'bootstrap'
import { ProductCoilSettingContext } from '../store/ProductCoilSettingContext.jsx';
import { ProductSelectContext } from '../store/ProductSelectContext.jsx';
import { StorefrontContext } from '../store/StorefrontContext.jsx';
import { set } from 'lodash';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import _ from 'lodash';
import * as Sentry from '@sentry/react';

function ProductsList() {
    // use storefrontClient instead of client
    const variables = "variant:title:'1001'";
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [products, setProducts] = useState([]);
    const [productPage, setProductPage] = useState(1);
    const { getAvailableCoils, productCoilSetting } = useContext(ProductCoilSettingContext);
    const { productSelected } = useContext(ProductSelectContext);
    const { state: storefrontStateObject, fetchMetaObject, fetchLocationId } = useContext(StorefrontContext);

    const showPaymentResult = (result) => {
        console.log('Payment result', result);
    }

    const PAGE_BTN_CLASS = "w-100 bg-light text-primary-emphasis fw-bold btn-lg"
    const MAX_PRODUCT_COUNT = 12

    const paymentFinish = (result) => {
        console.log('Payment finish');

        showPaymentResult(result);
        // dropProduct(1);
        // renew productList
        console.log('renew productList');
        // refetchProducts();
        // fetchProducts();
        fetchMetaObject();
    }

    function prepareProductList() {
        // get store front products and check if the product is available for sale
        const products = storefrontStateObject?.products;
        const availableCoils = getAvailableCoils();
        console.log('availableCoils', availableCoils);
        console.log('products', products);
        if (products?.length > 0) {
            const availableProducts = products.filter((product) => {
                return availableCoils.find((coil) => coil.productId === product.id);
            });
            console.log('availableProducts', availableProducts);
            setProducts(availableProducts);
            return
        }
        setProducts([]);
        return
    }

    function getMaxProductPage() {
        let maxProductPage = 1
        if (products?.length > 0) {
            maxProductPage = Math.ceil(products.length / MAX_PRODUCT_COUNT);
            console.log('maxProductPage', maxProductPage);
        }
        return maxProductPage;
    }

    useMemo(() => {
        console.log('storefrontStateObject.products / productCoilSetting updates', storefrontStateObject.products);
        setLoading(false)
        setError(null)
        prepareProductList();
        // setProducts(storefrontStateObject.products)
    }, [storefrontStateObject.products, productCoilSetting]);

    // trigger storefront api to get products every minute
    useEffect(() => {
        fetchMetaObject();
        fetchLocationId();
        const interval = setInterval(() => {
            console.log('fetchProducts');
            // fetchProducts();
            fetchMetaObject();
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error : {error.message}</p>;

    function getProductsForCurrentPage() {
        console.log('currentPage', productPage)
        const startIndex = (productPage - 1) * MAX_PRODUCT_COUNT;
        const endIndex = productPage * MAX_PRODUCT_COUNT;
        return products.slice(startIndex, endIndex);
    }

    return <Container
        // style={{
        //     ...(storefrontStateObject?.banner_object?.length > 0 &&
        //     {
        //         marginTop: "35vh"
        //     })
        // }}
        className="pb-5 text-center"
        id="products-list" 
    >
        {products?.length > 0 ?
            <>
                <PaymentProvider>
                    <div className="row justify-content-center my-2">
                        {/* each page shows 4 product, skip products for page  */}
                        {getProductsForCurrentPage().map((product, index) => {
                            // if (index < ((productPage - 1) * 4) || index >= (productPage * 4)) return null;
                            return <ProductItem key={product.id} product={product} />;
                        })}
                    </div>
                    {/* add 'd-none' to className if maxProductPage === 1 */}
                    <div
                        // spread content to left most and right most
                        className={`row justify-content-center my-2 ${getMaxProductPage() === 1 ? 'd-none' : ''}`}
                    >
                        <div className="col">
                            <Button
                                onClick={() => setProductPage(productPage - 1)}
                                disabled={productPage <= 1}
                                className={PAGE_BTN_CLASS}
                            >
                                &lt;
                            </Button>
                        </div>
                        <div className="col-1">
                            <Button
                                onClick={() => {
                                    setProductPage(1);
                                }}
                                className={PAGE_BTN_CLASS}
                            >
                                {/* home button */}
                                <i className="bi bi-house"></i>
                            </Button>
                        </div>
                        {/* set this div to fill all the space in row */}
                        <div className="col">
                            <Button
                                onClick={() => setProductPage(productPage + 1)}
                                disabled={productPage >= getMaxProductPage()}
                                className={PAGE_BTN_CLASS}
                            >
                                &gt;
                            </Button>
                        </div>
                    </div>
                    {productSelected && <Payment finish={paymentFinish} />}
                </PaymentProvider>
            </>
            :
            <p>No data found</p>
        }
    </Container>;
}



export default Sentry.withProfiler(ProductsList);